import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="border-t"
      style={{ 
        backgroundColor: 'var(--hr-bg)',
        borderColor: 'var(--hr-border)'
      }}
      data-testid="main-footer"
    >
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-['Playfair_Display'] text-lg font-semibold" style={{ color: 'var(--hr-text)' }}>
              Homely Rénovation
            </h3>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--hr-text-muted)' }}>
              Rénovation intérieure pilotée en Suisse romande.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Figtree'] font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/renovation-complete" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Rénovation complète</Link></li>
              <li><Link to="/services/salle-de-bain" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Salle de bain</Link></li>
              <li><Link to="/services/cuisine" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Cuisine</Link></li>
              <li><Link to="/services/plans-3d" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Plans 3D</Link></li>
              <li><Link to="/suivi-de-chantier" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Suivi de chantier</Link></li>
            </ul>
          </div>

          {/* Pages */}
          <div>
            <h4 className="font-['Figtree'] font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>Liens utiles</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/galerie-avant-apres" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Galerie</Link></li>
              <li><Link to="/faq" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>FAQ</Link></li>
              <li><Link to="/a-propos" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>À propos</Link></li>
              <li><Link to="/devis" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Demander un devis</Link></li>
            </ul>
          </div>

          {/* Zones */}
          <div>
            <h4 className="font-['Figtree'] font-semibold mb-4" style={{ color: 'var(--hr-text)' }}>Zones d'intervention</h4>
            <ul className="space-y-2 text-sm" style={{ color: 'var(--hr-text-muted)' }}>
              <li>Genève</li>
              <li>Lausanne</li>
              <li>Montreux</li>
              <li>Fribourg</li>
              <li>Neuchâtel</li>
              <li>Valais</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t flex flex-col sm:flex-row justify-between items-center gap-4" style={{ borderColor: 'var(--hr-border)' }}>
          <p className="text-sm" style={{ color: 'var(--hr-text-muted)' }}>
            © {currentYear} Homely Solutions. Tous droits réservés.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/mentions-legales" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>Mentions légales</Link>
            <Link to="/cgv" className="hover:opacity-70 transition-opacity" style={{ color: 'var(--hr-text-muted)' }}>CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}